import React, {  useEffect, useState } from 'react'
import 'd3-selection-multi'
import './styles.scss'
import '../globals.scss'
import { UpdateNote } from '@ta-interaktiv/contentbricks'
import { localesHospitalMultiples as locales } from '../locales'
import { LineOnly } from 'components/Charts_LineOnly'
import { chunkArray, KeyEntry } from '../globalDrawFunctions'

let countryCounter = 0

interface Props {
  capacityPeak?: [number, string]
}

const updateCountryCount = function(drawData) {
  let counter = 0
  for (let i = 0; i < drawData.length; i++) {
    counter += drawData[i].length
  }
  return counter
}

export const HospitalMultiples = ({ capacityPeak }: Props) => {
  const [drawData, setDrawData] = useState<cantonsData[][]>()
  const [showall, setShowAll] = useState<boolean>(true)
  const [countryCount, setCountryCount] = useState(0)

  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-spitalkapazitaeten/spitalkapazitaeten-int-new.json'
    )
      .then(response => {
        return response.json()
      })
      .then(json => {
        setDrawData(chunkArray(json, 6))
        countryCounter = updateCountryCount(chunkArray(json, 6))
        setCountryCount(countryCounter)
      })
  }, [])

  return (
    <div className='ui vertical segment' style={{ overflow: 'visible' }}>
      {drawData && (
        <>
          {' '}
          <div className='ui container chart'>
            <UpdateNote updating={locales.update} />
            <h3>{locales.title}</h3>
            <div className='subtitle'>
              {locales.sublineStart} {countryCount} {locales.sublineEnd}
            </div>

            <div className='key'>
              <KeyEntry iconFile='legende_hosp.png' text={locales.keyHosp} />
              <KeyEntry
                iconFile='legende_intens.png'
                text={locales.keyIntensive}
              />
            </div>
          </div>
          <div className='cantonsMultiples'>
            <div className='ui container'>
              <div className='personalGrid'>
                {drawData.map((drawRow: cantonsData[], rnr: number) => {
             
                  return (
                    <React.Fragment key={rnr}>
                      {drawRow.map((e: cantonsData, i: number) => {
                        const maxHosp = Math.max(...e.data.map(o => o.hosp), 0)
                        const maxInte = Math.max(
                          ...e.data.map(o => o.intense),
                          0
                        )

                        let rHosp = 50
                        let scaleMaxHosp =
                          Math.ceil((maxHosp * 2.2) / rHosp) * rHosp
                        if (scaleMaxHosp === 0) scaleMaxHosp = rHosp

                        let rInte = 10
                        let scaleMaxInte =
                          Math.ceil((maxInte * 2.2) / rInte) * rInte
                        if (scaleMaxInte === 0) scaleMaxInte = rInte

                        return (
                          <React.Fragment key={i}>
                            <div
                              className={'col' + (rnr === 0 ? ' first' : '')}
                              key={i}
                            >
                              <div className='chartMeta'>
                                <div className='name'>{e.name}</div>
                              </div>
                              <LineOnly
                                line={e.data.filter(f => +f.hosp >= 0)}
                                yProp='hosp'
                                xDomain={[0, e.data.length]}
                                className='hospital'
                                yDomain={[scaleMaxHosp, 0]}
                                yTicks={{
                                  lines: [0, scaleMaxHosp],
                                  text: [scaleMaxHosp]
                                }}
                                isFirst={true}
                                start={e.start}
                                noData={!e.hosp}
                              />
                              <LineOnly
                                line={e.data.filter(f => +f.intense >= 0)}
                                yProp='intense'
                                xDomain={[0, e.data.length]}
                                className='intensive'
                                yDomain={[scaleMaxInte, 0]}
                                yTicks={{
                                  lines: [0, scaleMaxInte],
                                  text: [scaleMaxInte]
                                }}
                                isFirst={true}
                                start={e.start}
                                noData={!e.icu}
                              />
                            </div>
                          </React.Fragment>
                        )
                      })}
                    </React.Fragment>
                  )
                })}
              </div>
            </div>

           
          </div>
        </>
      )}
    </div>
  )
}
export default HospitalMultiples
